import { ReactComponent as BenefitsRedIconSVG } from "./benefits-red-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconBenefitsRed(props) {
  return <SvgIcon {...props} component={BenefitsRedIconSVG} viewBox="0 0 26 26" />;
}